import { requestWithQuery } from '../../../shared/api/utils/provider';
import { ApiResponse } from '../../../shared/api/utils/responseTransform';
import { DriverDetails, DriverSearchResult } from '../../types/driver';

interface DriverQueryParams {
  q: string;
  state: string;
}

export async function getDrivers(queryParams: DriverQueryParams): Promise<ApiResponse<DriverSearchResult[]>> {
  if (queryParams.q) {
    return requestWithQuery({ url: '/care/drivers', method: 'GET', params: queryParams });
  }
  throw new Error('Query cannot be empty');
}

export async function addDriver(rideSlug, data): Promise<ApiResponse<DriverDetails>> {
  return requestWithQuery({ url: `/care/rides/${rideSlug}/add_driver`, method: 'POST', data: data });
}

export async function removeDriverFromCart(rideSlug): Promise<ApiResponse<DriverDetails>> {
  return requestWithQuery({ url: `/care/rides/${rideSlug}/remove_from_cart`, method: 'POST' });
}
